export default __webpack_public_path__ + "i18n/translations/translation-pl.70f88d6a.json";